import client from "../../client/client";
import { encodeParam } from "../../utils/utils";

class ProjectDocumentService {
	uploadNewVersion({ prevDocumentId }, file, progressCallback, cancelToken) {
		return client.upload(`/documents/${prevDocumentId}/uploads`, file, {
			config: { cancelToken, onUploadProgress: progressCallback },
		});
	}

	checkDocumentForVersioning({ newDocId }, cancelToken) {
		return client.get(`/documents/version/${newDocId}`, {
			config: { cancelToken },
		});
	}

	associateNewVersionOfDoc({ oldDocId, newDocId }, cancelToken) {
		return client.post(`/documents/${oldDocId}/version/${newDocId}`, {
			config: { cancelToken },
		});
	}

	search({ projectId }, { name, page = 0, limit = 15 }, cancelToken) {
		return client.get(`projects/${projectId}/documents`, {
			params: { name: encodeParam(name), page, limit },
			config: { cancelToken },
		});
	}

	getCompanyDocumentSpecificRoleUsers({ projectId, docId, role }, cancelToken) {
		return client.get(`projects/${projectId}/documents/${docId}/roles/${role}`, { config: { cancelToken } });
	}

	getDocuments({ projectId }, cancelToken) {
		return client.get(`projects/${projectId}/documents/all`, { config: { cancelToken } });
	}

	getAllDetailedDocuments({ projectId }, cancelToken) {
		return client.get(`projects/${projectId}/documents/all/me/roles`, { config: { cancelToken } });
	}

	getCost({ projectId }, cancelToken) {
		return client.get(`projects/${projectId}/documents/cost`, { config: { cancelToken } });
	}

	getDocumentsPrecedence({ projectId }, { filter }, cancelToken) {
		return client.get(`/projects/${projectId}/documents/precedence`, {
			params: { filter },
			config: { cancelToken },
		});
	}

	updateDocumentTypes({ projectId }, { docIds, dirIds, type }, cancelToken) {
		return client.patch(`/projects/${projectId}/type`, {
			payload: { docIds, dirIds, type },
			config: { cancelToken },
		});
	}

	getUploads({ projectId }, cancelToken) {
		return client.get(`projects/${projectId}/documents/uploads`, { config: { cancelToken } });
	}

	uploadDocuments({ projectId }, files, { directoryId }, progressCallback, cancelToken) {
		return client.upload(`/projects/${projectId}/documents/uploads`, files, {
			payload: { directoryId },
			config: { cancelToken, onUploadProgress: progressCallback },
		});
	}

	projectHasDocuments({ projectId }, cancelToken) {
		return client.get(`projects/${projectId}/documents/exist`, { config: { cancelToken } });
	}

	getAllDocVersionCandidates(
		{ projectId },
		{ page = 0, limit = 15, sort = undefined, direction = undefined },
		cancelToken
	) {
		return client.get(`/projects/${projectId}/version/candidates`, {
			params: { page, limit, sort, direction },
			config: { cancelToken },
		});
	}

	updateBulkVersioningCandidatesStatus({ projectId }, { payload }, cancelToken) {
		return client.patch(`/projects/${projectId}/version/bulk`, {
			payload,
			config: { cancelToken },
		});
	}

	getAllDocVersionCandidateCount({ projectId }, cancelToken) {
		return client.get(`/projects/${projectId}/version/candidates/count`, {
			config: { cancelToken },
		});
	}

	getAllSimilarDocVersionCandidates({ projectId, candidateId }, cancelToken) {
		return client.get(`/projects/${projectId}/version/candidates/${candidateId}/similar`, {
			config: { cancelToken },
		});
	}

	getAllSimilarDocVersionCandidatesForSelection({ projectId }, { candidateIds }, cancelToken) {
		return client.post(`/projects/${projectId}/version/candidates/similar`, {
			payload: candidateIds,
			config: { cancelToken },
		});
	}

	getCompletedDocument({ projectId }, cancelToken) {
		return client.get(`/projects/${projectId}/documents/complete`, {
			config: { cancelToken },
		});
	}
}

export default new ProjectDocumentService();
